import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Aux from '../Aux/Aux';
import Toolbar from '../Navigation/Toolbar/Toolbar';
import Footer from '../Footer/Footer';
import SideDrawer from '../Navigation/SideDrawer/SideDrawer';

const MainAndFooterContainer = styled.div.attrs({})`
  position: absolute;
  top: 56px;
  width: 100%;
`;

const Main = styled.main.attrs({
  className: 'flex flex-column justify-between items-center'
})`
  width: 100%;
`;

class Layout extends Component {
  state = {
    showSideDrawer: false
  };

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState(prevState => {
      return { showSideDrawer: !prevState.showSideDrawer };
    });
  };

  render() {
    return (
      <Aux>
        <Toolbar
          className="Toolbar"
          drawerToggleClicked={this.sideDrawerToggleHandler}
        />
        <SideDrawer
          className="SideDrawer"
          open={this.state.showSideDrawer}
          closed={this.sideDrawerClosedHandler}
        />
        <MainAndFooterContainer className="MainAndFooterContainer">
          <Main className="Main">{this.props.children}</Main>
          <Footer className="Footer" />
        </MainAndFooterContainer>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    // isAuthenticated: state.auth.token !== null
  };
};

export default connect(mapStateToProps)(Layout);
